import React, { useEffect, useState } from "react";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import Footer from "../footer";

const VrindavanMarksheet = ({ student }) => {
  const [settings, setSettings] = useState("");
  useEffect(() => {
    setSettings(JSON.parse(localStorage.getItem("settings") ?? "{}"));
  }, []);
  return (
    <div className="">
      <div
        className="marksheet border p-4 bg-white"
        style={{ width: "900px", fontFamily: "Arial, sans-serif" }}
      >
        <div className="text-center mb-3">
          <h1 className="m-0 text-danger fw-bold">{settings?.name}</h1>
          <p className="m-0">
            {settings?.village} {settings?.district} {settings?.state}{" "}
            {settings?.pin_code}
          </p>
          <p className="m-0">
            📞 {settings?.mobile} {settings?.secondary_mobile}
          </p>
          <p className="m-0">✉️ {settings?.email}</p>

          <h5 className="fw-bold text-primary">Report Card</h5>
          <p>
            <strong>Academic Session:</strong> 2024-2025
          </p>
        </div>

        <div className="row mb-3">
          <div className="col-12">
            <table className="table table-bordered">
              <tbody>
                <tr>
                  <td>
                    <strong>Student's Name:</strong> {student.name}
                  </td>
                  <td>
                    <strong>Father's Name:</strong> {student.father}
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Mother's Name:</strong> {student.mother}
                  </td>
                  <td>
                    <strong>Date of Birth:</strong> {student.dob}
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Class:</strong> {student.class}
                  </td>
                  <td>
                    <strong>Section:</strong> {student.section}
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>S.R. No.:</strong> {student.srno}
                  </td>
                  <td>
                    <strong>Roll No.:</strong> {student.roll}
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>NIC ID:</strong> {student.nic}
                  </td>
                  <td>
                    <strong>APAAR ID:</strong> __
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <table className="table table-bordered text-center">
          <thead className="table-light">
            <tr>
              <th>Subject</th>
              <th>Half Yearly (100)</th>
              <th>Grade</th>
              <th>Annual Exam (100)</th>
              <th>Grade</th>
              <th>Total (200)</th>
              <th>Grade</th>
            </tr>
          </thead>
          <tbody>
            {student.subjects.map((subject, i) => (
              <tr key={i}>
                <td>{subject.name}</td>
                <td>{subject.half}</td>
                <td>{subject.grade1}</td>
                <td>{subject.annual}</td>
                <td>{subject.grade2}</td>
                <td>{subject.total}</td>
                <td>{subject.finalGrade}</td>
              </tr>
            ))}
            <tr className="fw-bold">
              <td>Grand Total</td>
              <td>{student.totalHalf}</td>
              <td>{student.gradeHalf}</td>
              <td>{student.totalAnnual}</td>
              <td>{student.gradeAnnual}</td>
              <td>{student.grandTotal}</td>
              <td>{student.gradeOverall}</td>
            </tr>
          </tbody>
        </table>

        <div className="row my-3">
          <div className="col">
            <strong>Grand Total:</strong> {student.grandTotal} / 600
          </div>
          <div className="col">
            <strong>Percentage:</strong> {student.percentage}%
          </div>
          <div className="col">
            <strong>Attendance:</strong> {student.attendance}
          </div>
          <div className="col">
            <strong>Discipline:</strong> {student.discipline}
          </div>
        </div>

        <div className="mb-3">
          <h5>Co-Scholastic Area</h5>
          <table className="table table-bordered text-center">
            <thead className="table-light">
              <tr>
                <th>Area</th>
                <th>Term-1</th>
                <th>Term-2</th>
              </tr>
            </thead>
            <tbody>
              {student.coscholastic.map((item, i) => (
                <tr key={i}>
                  <td>{item.area}</td>
                  <td>{item.term1}</td>
                  <td>{item.term2}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="row">
          <div className="col-6">
            <p>
              <strong>Final Result:</strong> {student.result}
            </p>
          </div>
          <div className="col-6 text-end">
            <p>
              <strong>Promoted to Class:</strong> {student.promotedTo}
            </p>
          </div>
        </div>

        <div className="mb-3">
          <p>
            <strong>Class Teacher's Remarks:</strong> {student.remarks}
          </p>
          <p>
            <strong>Date:</strong> {student.resultDate}
          </p>
        </div>

        <div className="d-flex justify-content-between px-4 mt-4">
          <strong>Class Teacher</strong>
          <strong>Principal</strong>
        </div>

        <div className="mt-4">
          <h6>Instructions</h6>
          <p className="mb-0">
            Grading scale for scholastic areas: Grades are awarded on an 8-point
            scale as follows:
          </p>
          <table className="table table-bordered text-center mt-2">
            <thead className="table-light">
              <tr>
                <th>Marks Range</th>
                <th>Grade</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>91-100</td>
                <td>A1</td>
              </tr>
              <tr>
                <td>86-90</td>
                <td>A2</td>
              </tr>
              <tr>
                <td>76-85</td>
                <td>B1</td>
              </tr>
              <tr>
                <td>71-75</td>
                <td>B2</td>
              </tr>
              <tr>
                <td>61-70</td>
                <td>C1</td>
              </tr>
              <tr>
                <td>51-60</td>
                <td>C2</td>
              </tr>
              <tr>
                <td>41-50</td>
                <td>D</td>
              </tr>
              <tr>
                <td>Below 40</td>
                <td>E (Needs Improvement)</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default function CertificateMarksheet() {
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSection, setSelectedSection] = useState("");
  const [selectedStudent, setSelectedStudent] = useState("");
  const [selectAllStudents, setSelectAllStudents] = useState(false);
  const [showCard, setShowCard] = useState(false);

  const allStudents = ["John", "Ravi", "Pooja", "Vishu", "Laxu", "Sneha"];

  const handleSearch = () => {
    if (
      selectedClass &&
      selectedSection &&
      (selectedStudent || selectAllStudents)
    ) {
      setShowCard(true);
    } else {
      alert("Please select all required fields.");
    }
  };

  const handlePrint = () => {
    window.print();
  };

  const student = {
    name: selectedStudent || "All Students",
    father: "Mr. Sharma",
    mother: "Mrs. Sharma",
    class: selectedClass,
    section: selectedSection,
    roll: "23",
    dob: "01-01-2015",
    srno: "SR1234",
    nic: "NIC00001",
    subjects: [
      {
        name: "English",
        half: 78,
        grade1: "A2",
        annual: 80,
        grade2: "A2",
        total: 158,
        finalGrade: "A2",
      },
      {
        name: "Math",
        half: 90,
        grade1: "A1",
        annual: 88,
        grade2: "A2",
        total: 178,
        finalGrade: "A1",
      },
      {
        name: "Science",
        half: 75,
        grade1: "B1",
        annual: 82,
        grade2: "A2",
        total: 157,
        finalGrade: "A2",
      },
    ],
    totalHalf: 243,
    totalAnnual: 250,
    grandTotal: 493,
    gradeHalf: "A2",
    gradeAnnual: "A1",
    gradeOverall: "A1",
    percentage: 82.1,
    attendance: "94%",
    discipline: "A",
    coscholastic: [
      { area: "Drawing", term1: "A", term2: "A" },
      { area: "Games", term1: "B", term2: "A" },
    ],
    result: "Pass",
    promotedTo: "VII",
    remarks: "Very Good Performance",
    resultDate: "18-06-2025",
  };

  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <Header />
        <div className="layout-page">
          <Nav />
          <div className="content-wrapper">
            <div className="container-fluid py-4">
              <div className="card mt-4 p-4">
                <h3 className="mb-4 text-primary">
                  Generate Marksheet Certificate
                </h3>
                <div className="row g-3">
                  <div className="col-md-4">
                    <label className="form-label">Select Class *</label>
                    <select
                      className="form-select"
                      value={selectedClass}
                      onChange={(e) => setSelectedClass(e.target.value)}
                    >
                      <option value="">Select Class</option>
                      <option value="ONE">ONE</option>
                      <option value="TWO">TWO</option>
                      <option value="THREE">THREE</option>
                    </select>
                  </div>

                  <div className="col-md-4">
                    <label className="form-label">Select Section *</label>
                    <select
                      className="form-select"
                      value={selectedSection}
                      onChange={(e) => setSelectedSection(e.target.value)}
                    >
                      <option value="">Select Section</option>
                      <option value="A">A</option>
                      <option value="B">B</option>
                      <option value="C">C</option>
                    </select>
                  </div>

                  <div className="col-md-4">
                    <label className="form-label">Select Student *</label>
                    <select
                      className="form-select"
                      value={selectedStudent}
                      onChange={(e) => setSelectedStudent(e.target.value)}
                      disabled={selectAllStudents}
                    >
                      <option value="">Select Student</option>
                      {allStudents.map((s, index) => (
                        <option key={index} value={s}>
                          {s}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-12">
                    <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="selectAll"
                        checked={selectAllStudents}
                        onChange={(e) => setSelectAllStudents(e.target.checked)}
                      />
                      <label className="form-check-label" htmlFor="selectAll">
                        Generate for all students (batch-wise)
                      </label>
                    </div>
                  </div>

                  <div className="col-12 d-flex justify-content-end">
                    <button
                      onClick={handleSearch}
                      className="btn btn-primary px-4 mt-3"
                    >
                      Search
                    </button>
                  </div>
                </div>
              </div>

              {showCard && (
                <>
                  <div className="col-12 d-flex justify-content-end mb-5">
                    <button
                      onClick={handlePrint}
                      className="btn btn-success mt-3"
                    >
                      Print / Save as PDF
                    </button>
                  </div>
                  <VrindavanMarksheet student={student} />
                </>
              )}
            </div>
            <Footer />
            <div className="content-backdrop fade"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
